export function isAbortError(e: unknown): boolean {
  return (
    e instanceof Error && e.message.includes('user aborted a request')
  );
}
